import auth from "./auth";
import user from "./user";
import contract from "./contracts";
import payment from "./payment";
import plan from "./plan";
import point from "./point";
import ticket from "./ticket";
import tenant from "./tenant";

export default {
  auth,
  user,
  payment,
  plan,
  point,
  ticket,
  contract,
  tenant
};
